import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatChipInputEvent } from "@angular/material/chips";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertController, LoadingController } from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { AppService } from "src/app/services/app.service";
import { _getStorage } from "src/app/utils/local-storage";
import { ADDRESS } from "../../../text_control/text_address";
import { BTN } from "../../../text_control/text_button";
import { errMsg } from "../seller-add/seller-add.const";
import { errSelDataMsg } from "../seller-data/seller-data.const";

export interface Fruit {
  numbers: string;
}

export interface Faxs {
  numbers: string;
}

@Component({
  selector: "app-seller-detail",
  templateUrl: "./seller-detail.component.html",
  styleUrls: ["./seller-detail.component.scss"],
})
export class SellerDetailComponent implements OnInit {
  public text_addr: any = {};
  public text_btn: any = {};
  disableEdit = true;
  showBack = true;
  id = "";
  seller_id = "";
  seller_tax_id = "";
  seller_branch_id = "";
  seller_name = "";
  seller_branch_name = "";
  seller_storeid = "";
  bu = "";
  branch = "";
  source_system = "";
  seller_status: "active";
  created_time = "";

  building_name = "";
  building_no = "";
  village_no = "";
  room_no = "";
  floor = "";
  road = "";
  house_no = "";
  lane = "";
  email = "";
  postcode = "";
  sub_district = "";
  district = "";
  province = "";

  showbtn = true;
  btnback = true;
  seller_branch = "";
  seller_type = "1";
  fax = "";
  showCancAndSave = false;
  showBackAndEdit = true;
  updateSellerForm: FormGroup;
  body = {
    getsellerbyid: "",
  };

  phone1 = "";
  phone2 = "";
  phone3 = "";
  phone4 = "";
  phone5 = "";
  phone6 = "";

  response: any;
  showBtn1: boolean;
  showBtn2: boolean;

  showLoading = true;
  loading = true;
  dataAddress: any;

  dataProvince: any;
  groupAddress: any;
  groupProvince: any;
  isFindAddress = false;
  searchAddress = "";
  searchProvince = "";
  addressManual = false;
  faxs: any = [];

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  @ViewChild("inputBranchStoreId", { static: false })
  inputBranchStoreId;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiserviceService,
    private fb: FormBuilder,
    public loadingController: LoadingController,
    private alertController: AlertController,
    private router: Router,
    public appService: AppService
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.text_addr = ADDRESS;
    this.text_btn = BTN;
    this.route.queryParams.subscribe((param) => {
      this.body.getsellerbyid = param["id"];
      this.loadingSellerData();
    });
  }
  ionViewDidEnter() {
    this.showBackAndEdit = true;
  }

  ionViewWillLeave() {
    this.showLoading = true;
  }

  ngOnInit() {
    this.isFindAddress = false;
    this.groupAddress = this.appService.address_thai;
    let groupData = [];
    this.groupAddress.forEach((v, i) => {
      const index = groupData.findIndex((f) => f.province === v.province);
      if (index === -1) {
        groupData = [...groupData, v];

        this.dataProvince = groupData;
      } else {
        return;
      }
    });
    window.onclick = function (event) {
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      var showprovince = document.getElementById("showSelectProvince");
      var notshowprovince = document.getElementById("notshowselectProvince");
      if (x !== null) {
        x.style.display = "none";
        y.style.display = "none";
      }
      if (showprovince !== null) {
        showprovince.style.display = "none";
        notshowprovince.style.display = "none";
      }
    };
  }

  filterAddress(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupAddress = this.appService.address_thai.filter((item) => {
        return (
          String(item.zipcode).indexOf(val) > -1 ||
          item.province.indexOf(val) > -1 ||
          item.amphoe.indexOf(val) > -1 ||
          item.district.indexOf(val) > -1
        );
      });
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }

  selectAddress(item) {
    this.sub_district = item.district;
    this.district = item.amphoe;
    this.province = item.province;
    this.postcode = item.zipcode;
    this.isFindAddress = false;
    this.searchAddress = "";
  }

  checkpostcode(e) {
    this.postcode = e.target.value.match(/[0-9]*/)[0];
  }
  filterProvince(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupProvince = this.dataProvince.filter((item) => {
        return item.province.indexOf(val) > -1;
      });
      var x = document.getElementById("showSelectProvince");
      var y = document.getElementById("notshowselectProvince");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }
  selectProvince(item) {
    this.province = item.province;
    this.searchProvince = "";
  }
  clearAddress(name) {
    if (name === "Postcode") {
      this.postcode = "";
    }
    if (name === "Province") {
      this.province = "";
    }
    if (name === "District") {
      this.district = "";
    }
    if (name === "SubDistrict") {
      this.sub_district = "";
    }
  }

  sellerDataValidate(response) {
    if (typeof response !== "object") {
      return { result: false, errMsg: errSelDataMsg.typeErr };
    }
    if (!response.hasOwnProperty("data")) {
      return { result: false, errMsg: errSelDataMsg.typeErr };
    }
    if (response.statusCode !== 200) {
      return { result: false, errMsg: response.statusMessage };
    }
    return { result: true };
  }

  async loadingSellerData() {
    const response = await this.apiService._post(
      this.apiService.apiUrl + this.apiService.getSellerDetail,
      this.body
    );
    console.log("response", response);
    let dataAddress;
    const valid = this.sellerDataValidate(response);
    try {
      if (!valid.result) {
        const alert = await this.alertController.create({
          cssClass: "my-custom-class",
          message: valid.errMsg,
        });
        await alert.present();
        this.loading = false;
        this.showLoading = false;
      } else {
        this.showLoading = false;
        this.loading = false;
        let res = response.data[0];
        this.id = res.id;
        this.seller_id = res.seller_id;

        this.dataAddress = response.data[0].address_detail[0];

        this.resAddress(res);
        if (this.dataAddress.fax !== "") {
          console.log("IN IF faxs : ", this.dataAddress.fax);
          let fax_str =
            this.dataAddress.fax.indexOf(",") > -1
              ? this.dataAddress.fax.split(",")
              : [this.dataAddress.fax];
          this.faxs = [];
          for (let i of fax_str) {
            console.log("i : ", i);
            this.faxs.push({
              numbers: i,
            });
          }
        } else {
          this.faxs = [];
        }
        if (this.dataAddress.phone !== "") {
          let phone: any = [];
          phone = this.dataAddress.phone.split("+");
          // console.log("dataAddress phone......", phone);

          phone =
            this.dataAddress.phone.indexOf(",") > -1
              ? [this.dataAddress.phone]
              : this.dataAddress.phone.split("+");
          for (let i = 0; i < phone.length; i++) {
            let arrphone: any;
            if (phone[1] !== "") {
              arrphone = phone[1].split("-");
              // console.log("arrphone......", arrphone);
              this.phone1 = arrphone[0];
              this.phone2 = arrphone[1];
              this.phone3 = arrphone[2] === undefined ? "" : arrphone[2];
            }
            if (phone[2] !== "") {
              arrphone = phone[2].split("-");
              this.phone4 = arrphone[0];
              this.phone5 = arrphone[1];
              this.phone6 = arrphone[2] === undefined ? "" : arrphone[2];
            }
          }
        } else {
          this.fruits = [];
        }
      }
    } catch (e) {}
  }
  checkBtn() {
    this.disableEdit = false;
    this.showBtn1 = false;
    this.showBtn2 = true;
  }
  goBack() {
    this.router.navigate(["/seller-data"]);
  }
  editData() {
    this.disableEdit = false;
    this.showBackAndEdit = false;
    this.showCancAndSave = true;
    this.showBack = false;
  }
  cancelEdit() {
    this.disableEdit = true;
    this.showBackAndEdit = true;
    this.showCancAndSave = false;
  }

  async addSelAlert(alrtMsg) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: alrtMsg,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {},
        },
      ],
    });
    alert.present();
  }
  async updateSellerData() {
    let isConfirm = false;
    let seller_tax_id = String(this.seller_tax_id);
    let province: any = this.province;
    let district: any = this.district;
    let sub_district: any = this.sub_district;
    let phones = [];
    let fax_list = [];

    phones[0] =
      this.phone1 != ""
        ? "+" +
          this.phone1 +
          (this.phone2 != ""
            ? "-" + this.phone2 + (this.phone3 != "" ? "-" + this.phone3 : "")
            : "")
        : "";
    phones[1] =
      this.phone4 != ""
        ? "+" +
          this.phone4 +
          (this.phone5 != ""
            ? "-" + this.phone5 + (this.phone6 != "" ? "-" + this.phone6 : "")
            : "")
        : "";

    console.log("phones.........array.........", phones);
    console.log("phones.........join()........", phones.join(""));

    if (this.faxs && this.faxs.length > 0) {
      for (let f of this.faxs) {
        fax_list.push(f.numbers);
      }
    }

    if (!isConfirm) {
      if (this.seller_name === "") {
        this.addSelAlert(errMsg.reqSelName);
      } else if (seller_tax_id.length != 13) {
        this.addSelAlert(errMsg.reqTaxId);
      } else if (!this.appService.checkIdentityCardNumber(seller_tax_id)) {
        this.addSelAlert(errMsg.reqSelTaxId);
      } else if (this.bu === "") {
        this.addSelAlert(errMsg.bu);
      } else if (this.seller_storeid === "") {
        this.addSelAlert(errMsg.seller_storeid);
      } else if (this.seller_branch_id === "") {
        this.addSelAlert(errMsg.seller_branch_id);
      } else if (this.branch === "") {
        this.addSelAlert(errMsg.branch);
      } else if (this.house_no === "") {
        this.addSelAlert(errMsg.house_no);
      } else if (this.postcode === "") {
        this.addSelAlert(errMsg.postcode);
      } else if (district === "") {
        this.addSelAlert(errMsg.district);
      } else if (sub_district === "") {
        this.addSelAlert(errMsg.sub_district);
      } else if (province === "") {
        this.addSelAlert(errMsg.province);
      } else if (this.phone1 != "" || this.phone2 != "") {
        if (
          String(this.phone1).length !== 2 &&
          String(this.phone1).length !== 3
        ) {
          this.addSelAlert(errMsg.phone1);
        } else if (
          String(this.phone2).length < 6 ||
          String(this.phone2).length > 10
        ) {
          this.addSelAlert(errMsg.phone2);
        } else if (this.phone4 != "" || this.phone5 != "") {
          if (
            String(this.phone4).length !== 2 &&
            String(this.phone4).length !== 3
          ) {
            this.addSelAlert(errMsg.phone1);
          } else if (
            String(this.phone5).length < 6 ||
            String(this.phone5).length > 10
          ) {
            this.addSelAlert(errMsg.phone2);
          } else {
            isConfirm = true;
          }
        } else {
          isConfirm = true;
        }
      } else if (this.phone4 != "" || this.phone5 != "") {
        if (
          String(this.phone4).length !== 2 &&
          String(this.phone4).length !== 3
        ) {
          this.addSelAlert(errMsg.phone1);
        } else if (
          String(this.phone5).length < 6 ||
          String(this.phone5).length > 10
        ) {
          this.addSelAlert(errMsg.phone2);
        } else {
          isConfirm = true;
        }
      } else if (this.source_system == "") {
        this.addSelAlert(errMsg.source_system);
      } else {
        isConfirm = true;
      }
    }

    if (isConfirm) {
      const data = {
        updateSellerData: {
          id: this.id,
          seller_id: this.seller_id,
          seller_tax_id: seller_tax_id,
          seller_branch_id: String(this.seller_branch_id.padStart(5, "0")),
          seller_name: this.seller_name,
          seller_branch_name: this.seller_branch_name,
          bu: this.bu,
          branch: this.branch,
          source_system: this.source_system,
          userid: this.userID,
          seller_storeid: this.seller_storeid,
          seller_status: this.seller_status,
          address_detail: {
            addr_id: this.dataAddress.addr_id,
            building_no: this.building_no,
            building_name: this.building_name,
            room_no: this.room_no,
            floor: this.floor,
            house_no: this.house_no,
            village_no: this.village_no,
            lane: this.lane,
            road: this.road,
            sub_district: this.sub_district,
            district: this.district,
            province: this.province,
            postcode: String(this.postcode),
            phone: phones.join(""),
            fax: fax_list.join(","),
            email: this.email,
            address_status: this.seller_status,
            buyer_id: "",
            seller_id: this.id,
            addr_agree_tmp: "Y",
            user_id: this.userID,
          },
        },
      };
      console.log(
        "[=============== req updateSellerData ===============]",
        data
      );
      try {
        this.apiService
          ._post(this.apiService.apiUrl + this.apiService.editSeller, data)
          .then(async (res: any) => {
            console.log("========== res update Seller============", res);
            if (res.statusCode === 200) {
              const alert = await this.alertController.create({
                cssClass: "my-confirm-alert",
                header: "บันทึกข้อมูลเรียบร้อย",
                buttons: [
                  {
                    text: "OK",
                    cssClass: "alertButton",
                    handler: (blah) => {
                      this.showBackAndEdit = false;
                      this.showCancAndSave = false;
                      this.disableEdit = true;
                      this.showBack = true;
                    },
                  },
                ],
              });
              await alert.present();
            } else {
              this.ErrorMsg(res.statusMessage);
            }
          });
      } catch (error) {
        // this.ErrorMsg(errMsg.error);
      }
    }
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
  checkphone1(e) {
    this.phone1 = e.target.value.match(/[0-9-]*/);
  }
  checkphone2(e) {
    this.phone2 = e.target.value.match(/[0-9-]*/);
  }
  checkphone3(e) {
    this.phone3 = e.target.value.match(/[0-9-]*/);
  }
  checkphone4(e) {
    this.phone4 = e.target.value.match(/[0-9-]*/);
  }
  checkphone5(e) {
    this.phone5 = e.target.value.match(/[0-9-]*/);
  }
  checkphone6(e) {
    this.phone6 = e.target.value.match(/[0-9-]*/);
  }
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  dataphone: any;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  fruits: Fruit[];

  add(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    console.log("----value fruits", this.fruits);
    console.log("----value ", value);

    // Add our fruit
    if ((value || "").trim()) {
      this.fruits.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(fruit: Fruit): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  visiblefaxs = true;
  selectablefaxs = true;
  removablefaxs = true;
  addOnBlurfaxs = true;
  readonly separatorKeysCodesfaxs: number[] = [ENTER, COMMA];

  addfaxs(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    console.log("----value faxs", this.faxs);
    console.log("----value ", value);

    // Add our fruit
    if ((value || "").trim()) {
      this.faxs.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  removefaxs(fax: Faxs): void {
    const index = this.faxs.indexOf(fax);

    if (index >= 0) {
      this.faxs.splice(index, 1);
    }
  }

  async updateSelAlrt(msg) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: msg,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {},
        },
      ],
    });
    alert.present();
  }
  checkTaxInvoiceInput(e) {
    this.seller_tax_id = e.target.value.match(/[0-9]*/);
  }

  checkbranchid(e) {
    this.seller_branch_id = e.target.value.match(/[0-9]*/)[0];
  }
  onChangeBranchStoreId(value) {
    let regexp = /^[A-Za-z0-9]+$/;
    if (!value) {
      this.seller_storeid = "";
    }
    if (!regexp.test(value)) {
      this.inputBranchStoreId.value = value.replace(/[^A-Za-z0-9]/g, "");
    } else {
      this.seller_storeid = value;
    }
  }

  checkemail(e) {
    this.email = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }

  checkphone(e, n) {
    // console.log("checkdata e ", e);
    // console.log("checkdata n ", n);
    if (n == 1) {
      if (isNaN(this.dataAddress.phone) || e.key == " ") {
        this.dataAddress.phone = this.dataAddress.phone.slice(0, -1);
      }
    }
  }

  checkfaxs(e, n) {
    this.fax = e.target.value.match(/[0-9]*/)[0];
  }
  resAddress(res: any) {
    this.seller_id = res.seller_id;
    this.seller_tax_id = res.seller_tax_id;
    this.seller_branch_id = res.seller_branch_id;
    this.seller_name = res.seller_name;
    this.seller_branch_name = res.seller_branch_name;
    this.seller_storeid = res.seller_storeid;
    this.bu = res.bu;
    this.branch = res.branch;
    this.source_system = res.source_system;
    this.seller_status = res.seller_status;

    this.building_name = this.dataAddress.building_name;
    this.building_no = this.dataAddress.building_no;
    this.village_no = this.dataAddress.village_no;
    this.room_no = this.dataAddress.room_no;
    this.floor = this.dataAddress.floor;
    this.road = this.dataAddress.road;
    this.house_no = this.dataAddress.house_no;
    this.lane = this.dataAddress.lane;
    this.email = this.dataAddress.email;
    this.postcode = this.dataAddress.postcode;
    this.sub_district = this.dataAddress.sub_district;
    this.district = this.dataAddress.district;
    this.province = this.dataAddress.province;
  }
}
